export function FreezeObjectProperty(target, propertyKey) {
    const descriptor = Object.getOwnPropertyDescriptor(target, propertyKey);
    if (descriptor === void 0) {
        throw new Error(`Missing property ${String(propertyKey)}`);
    }
    else {
        const value = target[propertyKey];
        Object.defineProperty(target, propertyKey, {
            enumerable: descriptor.enumerable,
            configurable: false,
            get: () => value,
        });
    }
    return target;
}
export function FreezeObjectProperties(target, propertyKeys) {
    const iterator = propertyKeys[Symbol.iterator]();
    let result;
    while (!(result = iterator.next()).done) {
        FreezeObjectProperty(target, result.value);
    }
    return target;
}
//# sourceMappingURL=freeze-property.js.map